// extracted by mini-css-extract-plugin
module.exports = {"table":"style__table__BfGkk","pageWrap":"style__pageWrap__bDf88"};